export type PublishedArticleSummary = {
  id: string;
  headline: string;
  author: string;
  body: string;
  imageUrl: string;
  geoText?: string;
  slug?: string;
  date: string;
};

export type PublishedArticleDetail = PublishedArticleSummary & {
  imageId: number;
  imageLabel: string;
  status: string;
  slug: string;
  version: string;
};

export async function fetchPublishedArticles(
  accessAuthToken?: string
): Promise<PublishedArticleSummary[]> {
  const url = `${process.env.REACT_APP_BACKEND_URL}/articles/published`;
  const headers: Record<string, string> = {};
  if (accessAuthToken) {
    headers.Authorization = `Bearer ${accessAuthToken}`;
  }
  const response = await fetch(url, { method: "GET", headers, credentials: "include" });
  if (!response.ok) {
    throw new Error("Failed to load articles");
  }
  return response.json();
}

export async function fetchPublishedArticleById(
  id: string,
  accessAuthToken?: string
): Promise<PublishedArticleDetail> {
  const url = `${process.env.REACT_APP_BACKEND_URL}/articles/published/${encodeURIComponent(id)}`;
  const headers: Record<string, string> = {};
  if (accessAuthToken) {
    headers.Authorization = `Bearer ${accessAuthToken}`;
  }
  const response = await fetch(url, { method: "GET", headers, credentials: "include" });
  if (!response.ok) {
    throw new Error("Failed to load article");
  }
  return response.json();
}

export async function fetchPublishedArticleBySlug(
  slug: string,
  accessAuthToken?: string
): Promise<PublishedArticleDetail> {
  const url = `${process.env.REACT_APP_BACKEND_URL}/articles/published/by-slug/${encodeURIComponent(slug)}`;
  const headers: Record<string, string> = {};
  if (accessAuthToken) {
    headers.Authorization = `Bearer ${accessAuthToken}`;
  }
  const response = await fetch(url, { method: "GET", headers, credentials: "include" });
  if (!response.ok) {
    throw new Error("Failed to load article");
  }
  return response.json();
}
